export const PMS_ANALYTICS_FLAGS = ['gdc_', 'flower_dispense_limit_'];
